import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";
import { Welder } from "@/api/williams/welders";
import { usePinWelder } from "./usePinWelder";
import { routes } from "../../routes";

export function useSaveWelder() {
  const queryClient = useQueryClient();
  const pinWelder = usePinWelder();

  return useMutation(async (welder: Welder) => {
    const updatedWelder = await api.saveWelder(welder);

    queryClient.setQueryData(queryKeys.welder.single(updatedWelder.welderId), updatedWelder);
    queryClient.invalidateQueries(queryKeys.welder.list());

    if (window.location.href.endsWith(routes.welder.create)) {
      // Automatically add new welders to favorites.
      pinWelder.mutate(updatedWelder.welderId);
    }

    return updatedWelder;
  });
}
